import { Injectable } from "@angular/core";
import { GraphService } from "@kernel/graphql/services/graph.service";
import { first, map } from "rxjs";
import { IPlan } from "@app/shared/payment/interfaces/plan.interfaces";
import { GqlResponseInterface } from "@kernel/graphql/interfaces/gql-response.interface";
import { PLAN_BASE_DATA_SHAPE } from "@app/shared/payment/datashapes/plan.datashape";

@Injectable()
export class PlanService {
  constructor(private graphService: GraphService) {}

  list(dataShape: string = PLAN_BASE_DATA_SHAPE) {
    return this.graphService
      .constructListingQuery<{
        listingPlans: { data: IPlan[] };
      }>([dataShape], "listingPlans")
      .pipe(
        first(),
        map(res => ({ ...res, data: res.data.listingPlans?.data }))
      );
  }

  getAll(dataShape: string = PLAN_BASE_DATA_SHAPE) {
    return this.graphService.constructQuery<GqlResponseInterface<IPlan[]>>([dataShape], "allPlans");
  }
}
